import React, { useState } from "react";
import {
  Grid,
  Box,
  Typography,
  Divider,
  MenuItem,
  Select,
} from "@mui/material";
import Header from "../Header";
import { styled } from "@mui/system";
import SettingsIcon from "@mui/icons-material/Settings";
import { DashAppProvider } from "./SubPages/DashAppContext";
import DashboardChillerBar from "./SubPages/DashboardChillerBar";
import DashboardCards from "./SubPages/DashboardCards";
import { DashboardBarChart } from "./SubPages/DashboardBarChart";

const Dashboard_App = () => {
  const [selectedTab, setSelectedTab] = useState("");
  const [latestDate, setLatestDate] = useState("");

  const handleTabChange = (newValue) => {
    setSelectedTab(newValue);
  };

  const handleDateChange = (latest_date) => {
    setLatestDate(latest_date);
  };
  return (
    <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
      <Header name="FDDPR Dashboard" />
      <Box
        sx={{
          height: "42rem",
          width: "100%",
          fontSize: "larger",
        }}
      >
        <DashAppProvider>
          <DashboardChillerBar selectedFamilyname={handleTabChange}></DashboardChillerBar>
          <DashboardCards family={selectedTab} date={handleDateChange}></DashboardCards>
          <DashboardBarChart  family={selectedTab}></DashboardBarChart>
        </DashAppProvider>
      </Box>
    </Box>
  );
};

export default Dashboard_App;
